import axios from "axios";

export const apiClient = axios.create({
  // baseURL: 'http://localhost:3500/api',
  baseURL: process.env.REACT_APP_API_BASE_URL + "/api",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    // Headers anti-caché globales
    "Cache-Control": "no-cache, no-store, must-revalidate",
    Pragma: "no-cache",
    Expires: "0",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (!token) {
      console.log(
        "No se encontró token en localStorage. Verificando sessionStorage...",
      );
    }
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // 🔥 IMPORTANTE: Agregar timestamp para evitar caché en GET requests
    if (config.method?.toLowerCase() === "get") {
      config.params = {
        ...config.params,
        _t: new Date().getTime(), // Timestamp único
      };
    }
    // Para Zebra TC26, forzar headers adicionales
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes("zebra") || userAgent.includes("tc26")) {
      config.headers["X-Device-Type"] = "handheld";
      config.headers["X-No-Cache"] = "true";
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

apiClient.interceptors.response.use(
  (response) => {
    console.log("Respuesta recibida en interceptor:", response);
    return response;
  }, // Si la respuesta es exitosa, simplemente retorna
  (error) => {
    if (error.response?.status === 401) {
      //Token expirado o inválido
      // console.warn("Token Expirado o inválido. Redirigiendo al login...");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/";
    }
    return Promise.reject(error);
  },
);
